/* global localData, validateEmailInput, Stripe */
const invoiceInput = document.querySelector('.order-form__invoice-option input');
const invoiceForm = document.querySelector('.order-form__invoice-form');
const selectFormateInput = document.querySelectorAll('.newspaper-format-selection input');
const changeAddressCheckbox = document.querySelectorAll('.address-change .checkbox');
const changeAddressItems = document.querySelectorAll('.address-change__item');

if (invoiceForm) {
  invoiceInput.addEventListener('change', (event) => {
    invoiceForm.classList.toggle('is-active', event.currentTarget.checked);
  });

  const toggleCheckbox = (toggle) => {
    changeAddressCheckbox.forEach((checkbox) => {
      checkbox.classList.toggle('is-active', toggle);
    });
  };

  const toggleAddressItems = (toggle) => {
    changeAddressItems.forEach((el) => {
      const checkboxInput = el.querySelector('input');
      el.classList.toggle('is-active', toggle);
      checkboxInput.checked = false;
    });
  };

  selectFormateInput.forEach((el) => {
    const parentElem = el.closest('.order-form__order-details');

    el.addEventListener('change', (event) => {
      const targetCheckbox = event.currentTarget.getAttribute('data-radio');
      toggleAddressItems(false);
      if (targetCheckbox === 'all') {
        toggleCheckbox(true);
      } else {
        toggleCheckbox(false);
        parentElem.querySelector(`[data-checkbox="${targetCheckbox}"]`).closest('.checkbox').classList.add('is-active');
      }
    });
  });
  changeAddressCheckbox.forEach((checkbox) => {
    const checkboxInput = checkbox.querySelector('input');
    checkboxInput.addEventListener('change', (event) => {
      const parentElem = event.target.closest('.address-change__item');
      parentElem.classList.toggle('is-active', event.currentTarget.checked);
    });
  });
  const contactSubscribeForms = (() => {
    const r = {
      button: document.querySelector('.order-form .btn'),
      contactForm: document.querySelector('.order-form'),
      notice: document.querySelector('form .validation-notice'),
      loadingHtml: document.querySelector('.loading'),
      sendAjax: () => {
        r.isValid = true;
        const formData = {};
        document.querySelectorAll('.order-form__personal-data input, .order-form__invoice-form.is-active input, .is-active .address-change__item-form input, .order-form input[type="radio"], .order-form input[type="hidden"]').forEach((input) => {
          const type = input.getAttribute('type');
          switch (type) {
            case 'hidden':
            case 'text':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!formData[input.name]) {
                  input.closest('.mod-input').classList.add('is-validation-failed');
                  r.isValid = false;
                } else {
                  input.closest('.mod-input').classList.remove('is-validation-failed');
                }
              }
              break;
            case 'radio':
              formData[input.name] = r.getRadioValue(input.closest('.radio-button-list__inner'));
              if (typeof input.getAttribute('required') === 'string' && !formData[input.name]) {
                input.closest('.radio-button-list').classList.add('is-validation-failed');
                r.isValid = false;
              } else {
                input.closest('.radio-button-list').classList.remove('is-validation-failed');
              }
              break;
            case 'email':
              formData[input.name] = input.value.trim();
              if (typeof input.getAttribute('required') === 'string') {
                if (!validateEmailInput(formData[input.name])) {
                  input.closest('.mod-input').classList.add('is-validation-failed');
                  r.isValid = false;
                } else {
                  input.closest('.mod-input').classList.remove('is-validation-failed');
                }
              }
              break;
            default:
          }
        });
        if (r.isValid) {
          r.loadingHtml.classList.add('is-active');
          const ajax = new XMLHttpRequest();
          const formDataInfo = new FormData();
          formDataInfo.append('action', formData.action);
          formDataInfo.append('inputs', JSON.stringify(formData));
          formDataInfo.append('lang', localData.lang);
          formDataInfo.append('nonce', formData.nonce);
          ajax.open('POST', localData.siteURL, true);
          ajax.onload = function () {
            const response = JSON.parse(ajax.responseText);
            if (response.data.stripe_session_id) {
              const stripe = Stripe(response.data.stripe_public_key);
              stripe.redirectToCheckout({
                sessionId: response.data.stripe_session_id,
              });
            } else if (response.data.status === 200) {
              window.location = response.data.url;
            } else {
              r.notice.innerHTML = response.data.msg;
              r.notice.hidden = false;
            }
            r.loadingHtml.classList.remove('is-active');
          };
          ajax.send(formDataInfo);
        }
      },
      getRadioValue: (radio) => {
        let data = '';
        radio.querySelectorAll('input').forEach((item) => {
          if (item.checked) {
            data = item.value;
          }
        });
        return data;
      },
      initButton: () => {
        r.button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          r.sendAjax();
        });
      },
    };
    return {
      initialize: () => {
        r.initButton();
      },
    };
  })();
  contactSubscribeForms.initialize();
}
